import * as types from './mutation-types';
import * as actions from './actions';

const state = {
  drawer: null,
}
const getters = {}

const mutations = {
  [types.SET_DRAWER] (state, drawer) {
    state.drawer = drawer;
  },
}

export default{
  state,
  actions,
  getters,
  mutations
}
